import { push } from 'connected-react-router';

export function redirectToWebForm() {
	return async dispatch => {
		dispatch(push('/web-form'));
	};
}
